export const SELECTION_CLASS = '.bb-sport-event__selection:not(.bb-sport-event__selection--inactive)';
export const SELECTION_SELECTED_CLASS = 'bb-sport-event__selection--selected';
export const GTM_BETSLIP_MODAL = 'betslip-modal';
